export default Symbol('protected')
